import { getVariantEnvironment } from 'owa-metatags/lib/getPhysicalRing';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

export interface PresenceCloudConfig {
    upsBaseUrl: string;
    presenceResource: string;
    trouterServiceUrl: string;
    registrarServiceUrl: string;
    ic3Resource: string;
    mriOrgSegment: string;
}

const WW_CONFIG: PresenceCloudConfig = {
    upsBaseUrl: 'https://teams.cloud.microsoft/ups/global',
    presenceResource: 'https://presence.teams.microsoft.com',
    trouterServiceUrl: 'https://go.trouter.teams.microsoft.com/v4/a',
    registrarServiceUrl: 'https://teams.microsoft.com/registrar/prod/v3/registrations',
    ic3Resource: 'https://ic3.teams.office.com',
    mriOrgSegment: 'orgid',
};

const GCCH_CONFIG: PresenceCloudConfig = {
    upsBaseUrl: 'https://gov.teams.microsoft.us/ups/global',
    presenceResource: 'https://presence.gov.teams.microsoft.us',
    trouterServiceUrl: 'https://go.trouter.gov.teams.microsoft.us/v4/a',
    registrarServiceUrl: 'https://gov.teams.microsoft.us/registrar/prod/v3/registrations',
    ic3Resource: 'https://ic3.gov.teams.microsoft.us',
    mriOrgSegment: 'gcch',
};

const DOD_CONFIG: PresenceCloudConfig = {
    upsBaseUrl: 'https://dod.teams.microsoft.us/ups/global',
    presenceResource: 'https://presence.dod.teams.microsoft.us',
    trouterServiceUrl: 'https://go.trouter.dod.teams.microsoft.us/v4/a',
    registrarServiceUrl: 'https://dod.teams.microsoft.us/registrar/prod/v3/registrations',
    ic3Resource: 'https://ic3.dod.teams.microsoft.us',
    mriOrgSegment: 'dod',
};

let cachedConfig: PresenceCloudConfig | undefined;

export function getPresenceCloudConfig(): PresenceCloudConfig {
    if (cachedConfig) {
        return cachedConfig;
    }

    if (!isGlobalFeatureEnabled('msplaces-presence-sovereign-cloud')) {
        cachedConfig = WW_CONFIG;
        return cachedConfig;
    }

    const environment = getVariantEnvironment();
    switch (environment) {
        case 'GccHigh':
            cachedConfig = GCCH_CONFIG;
            break;
        case 'DoD':
            cachedConfig = DOD_CONFIG;
            break;
        default:
            cachedConfig = WW_CONFIG;
            break;
    }

    return cachedConfig;
}

export function resetPresenceCloudConfigForTest(): void {
    cachedConfig = undefined;
}
